import React, { useState, useEffect, useMemo } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { SelectChangeEvent } from '@mui/material';
import Button from '@mui/material/Button';
import { TextComponent, SelectComponent } from '../uiComponents';
import { gritComponentStyles } from './gritComponentStyles';
import CONSTANTS from '../../constants/constants';
import isEqual from 'lodash/isEqual';

interface MetadataGeneratorComponentProps {
  metadata: any;
  data: any;
  changeHandler: (data: any) => void;
}
const convertIntoObject = (arr: any[]) =>
  arr.reduce((acc: any, curVal: any) => ({ ...acc, [curVal[0].trim()]: curVal[1].trim() }), {});

const convertIntoArray = (obj: any) => {
  const temp: any = [];
  for (let key in obj) temp.push([key, obj[key]]);
  return temp;
};
function MetadataGeneratorComponent({ metadata, data, changeHandler }: MetadataGeneratorComponentProps) {
  const [origData, setOrigData] = useState<any>();
  const [modifiedData, setModifiedData] = useState<any>();
  const [error, setError] = useState<boolean>(false);
  const classes = gritComponentStyles();

  useEffect(() => {
    isEqual(origData, modifiedData) ? setError(true) : setError(false);
  }, [modifiedData]);

  useEffect(() => {
    let metadataCopy: any = {};
    Object.keys(metadata).forEach((key: string) => {
      metadataCopy[key] = metadata[key]['value'];
    });
    if (Object.keys(metadataCopy).length > 0 && data.length > 0) {
      const actObj: any = convertIntoObject(data);
      for (let key in actObj) metadataCopy[key] = actObj[key];
      setOrigData(metadataCopy);
      setModifiedData(metadataCopy);
    }
    if (Object.keys(metadataCopy).length == 0 && data.length > 0) {
      const actObj: any = convertIntoObject(data);
      setOrigData(metadataCopy);
      setModifiedData(actObj);
    }
  }, [data, metadata]);

  const getHTMLElementType = (m: any) => {
    if (metadata.hasOwnProperty(m)) {
      return metadata[m].hasOwnProperty('options') ? 'Select' : 'Text';
    } else {
      return 'Text';
    }
  };

  const validateMetadata = (m: any, value: string) => {
    const validator =
      metadata.hasOwnProperty(m) && metadata[m].hasOwnProperty('validate') ? metadata[m]['validate'] : [];
    return validator.length === 0 ? '' : CONSTANTS.getValidatorMsg(validator, value, getMetaDataAttribute(m, 'label'));
  };

  const getMetaDataAttribute = (m: any, attribute: string) =>
    metadata.hasOwnProperty(m) && metadata[m].hasOwnProperty(attribute) ? metadata[m][attribute] : m;

  return (
    <>
      {modifiedData && (
        <>
          <div className={classes.flexCol}>
            {Object.keys(modifiedData).map((m: any) => {
              if (getHTMLElementType(m) === 'Text') {
                return (
                  <div key={m}>
                    <TextComponent
                      changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                        setModifiedData({ ...modifiedData, [m]: e.target.value });
                        if (validateMetadata(m, e.target.value).length === 0) {
                          console.log('setting error : false for ', m);
                          setError(false);
                        } else {
                          console.log('setting error : true for ', m);
                          setError(true);
                        }
                      }}
                      data={{
                        disabled: getMetaDataAttribute(m, 'disabled') === 'true' ? true : false,
                        style: { margin: 1, width: '97%' },
                        value: modifiedData[m],
                        label: getMetaDataAttribute(m, 'label'),
                        error: !!validateMetadata(m, modifiedData[m]),
                        helperText: validateMetadata(m, modifiedData[m]),
                      }}
                    />
                  </div>
                );
              } else if (getHTMLElementType(m) === 'Select') {
                return (
                  <div key={m}>
                    <SelectComponent
                      changeHandler={(e: SelectChangeEvent<string>) => {
                        setModifiedData({ ...modifiedData, [m]: e.target.value });
                      }}
                      data={{
                        style: { margin: 1, width: '97%' },
                        value:
                          modifiedData[m] ||
                          getMetaDataAttribute(m, 'value') ||
                          getMetaDataAttribute(m, 'options')[0]['value'],
                        label: getMetaDataAttribute(m, 'label'),
                        options: getMetaDataAttribute(m, 'options'),
                        // error: !!validateMetadata(m, modifiedData[m]),
                        // helperText: validateMetadata(m, modifiedData[m]),
                      }}
                    />
                  </div>
                );
              }
            })}
            <div className={classes.flexRowWrap}></div>
          </div>
          <footer className={classes.footer}>
            <Button
              variant="contained"
              color="primary"
              disabled={error}
              onClick={() => {
                changeHandler(convertIntoArray(modifiedData));
              }}
            >
              Submit
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                changeHandler(null);
              }}
            >
              Cancel
            </Button>
          </footer>
        </>
      )}
    </>
  );
}

// export default withAITracking(reactPlugin, MetadataGeneratorComponent);
export default MetadataGeneratorComponent;
